import { Utils } from '@/utils/Utils'
import { z } from 'zod'

export const postPromotionListSchema = z.object({
  serviceType: z.array(z.string()).nullable(),
  unitType: z.enum(['PCS', 'BOX']).nullable().optional(), // LP8658 — INBOUND 검색 시 PCS/BOX 필터
  status: z.string().nullable(),
  promotionStartDate: z.string().optional(),
  promotionEndDate: z.string().optional(),
  createdAtFrom: z.string().optional(),
  createdAtTo: z.string().optional(),
  partnerIds: z.array(z.string()),
  brandIds: z.array(z.string()),
  // LOGISPRD-10268 — 검색 필터 확장 (국가·정산 주기·할인 방식, null = 전체)
  // productBarcode 는 BE 계약으로 남기되 화면 입력은 없앴다 (LOGISPRD-11338)
  country: z.enum(['KR', 'JP']).nullable().optional(),
  settlementCycle: z.enum(['DAILY', 'MONTHLY']).nullable().optional(),
  discountType: z.enum(['RATE', 'FIXED']).nullable().optional(),
  productBarcode: z.string().nullable().optional(),
  categoryCode: z.string().nullable().optional(),
  // LOGISPRD-11309 — 프로모션 종류. 화면 전용 값이고, 요청에는 targetUnits 목록으로 바꿔 실린다
  // 상품 종류는 뺐다 (LOGISPRD-11338) — 상품 단위는 일반에 흡수된다
  promotionKind: z.enum(['NORMAL', 'ALL']).nullable().optional(),
})

export type PostPromotionListSchemaType = z.infer<typeof postPromotionListSchema>

// 검색 필터 초기값 설정
export const getInitForm = (parsedQs: Partial<PostPromotionListSchemaType> = {}) => {
  return {
    serviceType: Utils.emptyArrayToNull(Utils.normalizeToArray(parsedQs.serviceType)),
    unitType: parsedQs.unitType ?? null,
    status: parsedQs.status ?? null,
    promotionStartDate: parsedQs.promotionStartDate,
    promotionEndDate: parsedQs.promotionEndDate,
    createdAtFrom: parsedQs.createdAtFrom,
    createdAtTo: parsedQs.createdAtTo,
    partnerIds: Utils.normalizeToArray(parsedQs.partnerIds) ?? [],
    brandIds: Utils.normalizeToArray(parsedQs.brandIds) ?? [],
    country: parsedQs.country ?? null,
    settlementCycle: parsedQs.settlementCycle ?? null,
    discountType: parsedQs.discountType ?? null,
    // 입력 행이 없어졌으므로 세션·URL 에 남은 값도 걸지 않는다 (보이지 않는 필터, LOGISPRD-11338)
    productBarcode: null,
    categoryCode: parsedQs.categoryCode ?? null,
    // 세션·URL 에 남은 옛 'PRODUCT' 값은 종류 필터를 끈 상태(null)로 되돌린다 (LOGISPRD-11338 로 종류에서 빠졌다)
    promotionKind: parsedQs.promotionKind === 'NORMAL' || parsedQs.promotionKind === 'ALL' ? parsedQs.promotionKind : null,
  }
}
